import React from 'react';

export class Input extends React.Component {
	getValue() {
		return this.input.value;
	}

	handleKeyPress(e) {
		if (e.key === 'Enter') {
			this.props.onEnterPressed && this.props.onEnterPressed(this.getValue());
		}
	}
	render() {
		const props = this.props;
		return (
			<input className={props.className} onChange={() => props.onChange && props.onChange(this.getValue())}
				onClick={event => event.stopPropagation()}
				placeholder="Order #"
				ref={input => this.input = input}
				onKeyPress={e => this.handleKeyPress(e)}
				value={props.value} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/sidebarOrders/ordersFilter/Input.js